import { NavParams, Platform, ToastController, ViewController } from 'ionic-angular';
import { Component } from '@angular/core';
import { Base64ToGallery, Base64ToGalleryOptions } from '@ionic-native/base64-to-gallery';
import { PhotoLibrary } from '@ionic-native/photo-library';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import { platform } from 'os';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'qr-code-page',
  templateUrl: 'qrcode.html'
})
export class QRCodePage{
  qrcode: any = null;
  toast
  url
  constructor(
    private navParams: NavParams,
private base64ToGallery: Base64ToGallery,
    private photoLibrary: PhotoLibrary,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    public translateService: TranslateService,
    private platform:Platform
  ) { }

  ionViewDidLoad() {
    this.qrcode = this.navParams.data.qrcode;
    this.url = `data:image/png;base64,${this.qrcode}`
  }
  close() {
    this.viewCtrl.dismiss();
  }

  saveImage() {
    if(this.platform.is('ios')){
    htmlToImage.toPng(document.getElementById("saveqrcode")).then((dataUrl) =>{
      let img = new Image();
      img.crossOrigin = "anonymous";
      img.src = dataUrl;
      this.photoLibrary.requestAuthorization().then(() => {
        //@ts-ignore
        this.photoLibrary.saveImage(img.src, 'spooorts')
          .then((filePath) => {
            this.presentToast(this.translateService.instant("QR_CODE_SAVED"),"bottom", "permission-sheet")
          })
          .catch((err) => {
            this.presentToast(this.translateService.instant("QR_CODE_SAVING_ERROR"),"bottom", "permission-sheet")
          });
        }).catch(err => {
          console.error('Permission was not granted. ' + err);
          this.presentToast(this.translateService.instant("IMAGE_DENIED"),"bottom", "permission-sheet")
        });
      })
      .catch(err => {
        this.presentToast(this.translateService.instant("QR_CODE_SAVING_ERROR"),"bottom", "permission-sheet")
      });
    }else if(this.platform.is('android')){
        this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {
          //@ts-ignore
          this.photoLibrary.saveImage(this.url, 'spooorts')
            .then((filePath) => {
              this.presentToast(this.translateService.instant("QR_CODE_SAVED"),"bottom", "permission-sheet")
            })
            .catch((err) => {
              this.presentToast(this.translateService.instant("QR_CODE_SAVING_ERROR"),"bottom", "permission-sheet")
            });
          }).catch(err => {
            this.presentToast(this.translateService.instant("IMAGE_DENIED"),"bottom", "permission-sheet")
          });
    }
  }
  presentToast(message, position, cssclass) {
    if (this.toast) {
      this.toast.dismiss();
      this.toast = null;
    }
    // create a toast:
    this.toast = this.toastCtrl.create({
      message: message,
      cssClass: cssclass,
      position: position,
      duration: 1000
    });
    this.toast.present();
  }
}



// WEBPACK FOOTER //
// /src/pages/me/qrcode/qrcode.ts